
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_1cgmr_17",
  "full-width": "awsui_full-width_8cbea_1cgmr_44",
  "refresh": "awsui_refresh_8cbea_1cgmr_47",
  "disabled": "awsui_disabled_8cbea_1cgmr_53",
  "selected": "awsui_selected_8cbea_1cgmr_116",
  "icon": "awsui_icon_8cbea_1cgmr_128",
  "with-text": "awsui_with-text_8cbea_1cgmr_132",
  "with-no-text": "awsui_with-no-text_8cbea_1cgmr_141",
  "root": "awsui_root_8cbea_1cgmr_146",
  "segment-part": "awsui_segment-part_8cbea_1cgmr_178",
  "grouped": "awsui_grouped_8cbea_1cgmr_203",
  "grouped-only": "awsui_grouped-only_8cbea_1cgmr_203",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_1cgmr_207",
  "grouped-with-error": "awsui_grouped-with-error_8cbea_1cgmr_219",
  "grouped-with-warning": "awsui_grouped-with-warning_8cbea_1cgmr_219",
  "grouped-disabled": "awsui_grouped-disabled_8cbea_1cgmr_219",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_1cgmr_219",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_1cgmr_219",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_1cgmr_219",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_8cbea_1cgmr_219",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_1cgmr_222",
  "grouped-vertical-only": "awsui_grouped-vertical-only_8cbea_1cgmr_222",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_1cgmr_225",
  "grouped-row-first": "awsui_grouped-row-first_8cbea_1cgmr_228",
  "grouped-with-action": "awsui_grouped-with-action_8cbea_1cgmr_231",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_1cgmr_231",
  "select": "awsui_select_8cbea_1cgmr_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_1cgmr_364",
  "segment-count-3": "awsui_segment-count-3_8cbea_1cgmr_371",
  "segment-count-4": "awsui_segment-count-4_8cbea_1cgmr_378",
  "segment-count-5": "awsui_segment-count-5_8cbea_1cgmr_385",
  "segment-count-6": "awsui_segment-count-6_8cbea_1cgmr_392",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_1cgmr_399"
};
  